import React from 'react';
import SeriesCompareScatterChart from '../../components/charts/SeriesCompareScatterChart';
import MultiSeriesRadarChart from '../../components/charts/MultiSeriesRadarChart';
import ExpandableCard from '../../components/cards/ExpandableCard';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import DraftsIcon from '@material-ui/icons/Drafts';
import SendIcon from '@material-ui/icons/Send';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import StarBorder from '@material-ui/icons/StarBorder';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import Badge from '@material-ui/core/Badge';
import Chip from '@material-ui/core/Chip';
import  {
    XYPlot,
    XAxis,
    YAxis,
    HorizontalGridLines,
    VerticalGridLines,
    VerticalBarSeries,
    RadialChart,
    Hint
  } from 'react-vis';

import Journey from '../../components/Journey';
import PersonalizationAction from './PersonalizationAction';

const styles = theme => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    paperContainer: theme.mixins.gutters({
        paddingTop: 16,
        paddingBottom: 16,
        marginTop: 0,
    }),
    nested: {
        paddingLeft: theme.spacing.unit * 4,
    },
    margin: {
        margin: theme.spacing.unit * 2,
    },
});

class PageDetailInsights extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};

        this.handlePageSelected = this.handlePageSelected.bind(this);
        this.handleActionClick = this.handleActionClick.bind(this);
    }

    componentDidMount() {
        //this.createVisualization(this.props.data, this.props.width, this.props.height);
    }

    componentDidUpdate() {

    }

    handlePageSelected(item) {
        //load the sunburst for the clicked page
        //console.log(item.payload.testMetrics);
        this.setState({ testMetrics: item.payload.testMetrics });
        //navigate
    }

    handleActionClick(item)
    {
        console.log(item);
    }

    render() {

        const { classes, data } = this.props;
        const actionStyle = { 
            cursor:"pointer",
            color:'blue'
        };

        const defaultStyle = {
            width: '300px',
            height: '150px',
            margin: '0.5em',
            display: 'inline-block',
            verticalAlign: 'top'
        };


        let index = 0;
        let profileData = data.profiles.data;
        let journeyData = data.journey;
        
        let feed =  [
            {
                "id": "925c4f2b-c851-4889-801f-7dbfc9470988",
                "title": "Aha! Traffic from Campaign B has decreased with 89% the last 7 days",
                "description": "Traffic from Campaign B has historically performed very well with Value per Visit 0.84 above average Value per Visit, but traffic has decreased by 89% the last 7 days to a total of 25,196 visits.",
                "recommendation": "Consider increasing campaign spend to drive more high value traffic.",
                "importance": 3,
                "action": {"label": "Review", "url": "/insights/top-campaign-performance/show"},
                "thumbnail": "/campaign-decrease.png",
                "type": "system",
                "category": "traffic optimization",
                "format": 1,
                "timestamp": "2018-05-30T20:00:00Z",
                "openDetail": {"label": "Details", "url": "/insights/top-campaign-performance/show" }
            },
            {
                "id": "725c4f2b-c851-4889-801f-7dbfc9470988",
                "title": "Did you know that you are getting increased traffic from Campaign A?",
                "description": "Traffic from Campaign A, has increased by 38% the last 7 days to a total of 31,753 visits. However there’s low engagement, as Value per Visit is 1.12 below average Value per visit.",
                "recommendation": "Consider personalization with content that is aligned with Campaign A messaging.",
                "importance": 4,
                "action": {"label": "Review", "url": "/insights/top-campaign-performance/show"},
                "type": "system",
                "thumbnail": "/campaign.png",
                "category": "optimization",
                "format": 1,
                "timestamp": "2018-05-31T04:30:00Z",
                "openDetail": {"label": "Details", "url": "/insights/top-campaign-performance/show" }
            },
            {
                "id": "vvaac4f2b-c851-4889-801f-7dbfc9470988",
                "title": "Feature page requires attention",
                "description": "The Features page has a lot of traffic but is generating very little value for any visitors classified as 'urban hipster'",
                "recommendation": "Identified hidden personalization opportunities on the Features page.",
                "importance": 1,
                "type": "system",
                "action": {"label": "Review", "url": "/pages/cfc78652-2576-4056-9dae-ed0b993bcd84/show"},
                "category": "optimization",
                "format": 1,
                "timestamp": "2018-05-30T12:00:00Z"
            }];

        return (
            <div>
                <Grid container spacing={8}>
                    <Grid container spacing={24}>
                    {feed.map((item, idx) => 
                        <Grid item xs={4}>
                            <ExpandableCard key={index} content={item} style={defaultStyle} />
                        </Grid>
                    )}
                    </Grid>
                    <Grid item xs={12}>
                        <h2 variant="heading">Segments you should optimize for</h2>
                        <ListItem>
                            <ListItemIcon><AddAlertIcon/></ListItemIcon>
                            <Typography>You have 45,843 visitors matching Urban Hipster pattern with 0.78 below avg. VpV.  
                                (<u style={actionStyle} onClick={this.handleActionClick}>36K potential lift</u>)</Typography>
                                <PersonalizationAction data={{id:data.id}} />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><AddAlertIcon/></ListItemIcon>
                            <Typography>You have 31,753 visitors from Campaign A with 1.12 below avg. VpV (<u style={actionStyle} onClick={this.handleActionClick}>potential 35K</u>)</Typography>
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><AddAlertIcon/></ListItemIcon>
                            <Typography>You have 78,231 visitors from Japan with 0.34 below avg. VpV (<u style={actionStyle} onClick={this.handleActionClick}>potential 27K</u>)</Typography>
                        </ListItem>
                    </Grid>
                    <Grid item xs={12}>
                        <h2 variant="heading">High value segments, where you should increase traffic</h2>
                        <ListItem>
                            <ListItemIcon><AddAlertIcon/></ListItemIcon>
                            <Typography>
                                You have 12,353 visitors matching Business pattern with 1.07 above avg. VpV, these are mainly coming from email campaigns,
                                <u style={actionStyle} onClick={this.handleActionClick}>consider increasing email campaigns</u>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><AddAlertIcon/></ListItemIcon>
                            <Typography>
                            You have 25,196 visitors from Campaign B with 0.48 above avg. VpV, 
                                <u style={actionStyle} onClick={this.handleActionClick}>consider increasing campaign spend</u>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <ListItemIcon><AddAlertIcon/></ListItemIcon>
                            <Typography>
                                You have 15,386 visitors from Canada with 0.59 above avg. VpV, 
                                <u style={actionStyle} onClick={this.handleActionClick}>consider increasing spend in local campaigns</u>
                            </Typography>
                        </ListItem>
                    </Grid>

                    <div>
                        <h2>Audience behavioral profile for Features page</h2>
                    </div>
                    <Grid container spacing={4}>
                        {profileData.map((profile, idx) => 
                            <Grid item xs={4}>
                                <MultiSeriesRadarChart key={`krdr-${idx}`} id={`rdr-${idx}`} series={profile.series} />
                            </Grid>
                        )}
                    </Grid>

                    <Grid item xs={12}>
                        <div>
                            <h2>Journey Insights</h2>
                        </div>
                        <Journey key={'pagej'} data={journeyData} />
                        <ListItem>
                            <ListItemIcon><AddAlertIcon/></ListItemIcon>
                            <Typography>You have a higher percentage of visitors who are in the Awareness stage and don’t convert tonext stages,&nbsp;
                                <u style={actionStyle} onClick={this.handleActionClick}>consider adding low commitment content to build trust</u>
                            </Typography>
                        </ListItem>
                    </Grid>
                </Grid>
            </div>
        );
    }
}


export default withStyles(styles)(PageDetailInsights);


// WEBPACK FOOTER //
// ./src/pages/details/PageDetailInsights.js